/**
 * [NWF] Keeps the cart attribute `_nwf_meterware_limited` in sync with the payload that
 * nwf-meterware-limited.liquid renders (NWF-225). The checkout extension meterware-stock-snapshot
 * (naehwelt-core-app) only checks the variants listed there, so Meterware with "continue selling"
 * is never blocked. Same sync pattern as nwf-cart-staffel.js, which explains it in detail.
 */
(function () {
    'use strict';

    if (window.__nwfMeterwareLimitedInit) return;
    window.__nwfMeterwareLimitedInit = true;

    var ATTRIBUTE = '_nwf_meterware_limited';
    /* Stops a pathological ping-pong only; a settled pass resets it. */
    var MAX_PASSES = 3;
    var passes = 0;
    var running = false;

    function collectSections() {
        var sections = [];
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }),
        );
        return sections;
    }

    function sync() {
        if (running || passes >= MAX_PASSES) return;
        if (typeof FoxTheme === 'undefined' || !FoxTheme.routes || !FoxTheme.utils) return;

        var node = document.querySelector('[data-nwf-meterware-limited]');
        if (!node) return;

        var wanted = node.dataset.nwfMeterwareLimited || '';
        if (wanted === (node.dataset.nwfMeterwareLimitedCurrent || '')) {
            passes = 0;
            return;
        }

        running = true;
        var attributes = {};
        attributes[ATTRIBUTE] = wanted;
        var body = JSON.stringify({
            attributes: attributes,
            sections: collectSections(),
            sections_url: window.location.pathname,
        });

        fetch(FoxTheme.routes.cart_update_url, Object.assign({}, FoxTheme.utils.fetchConfig(), { body: body }))
            .then(function (response) {
                return response.json();
            })
            .then(function (cart) {
                passes += 1;
                /* An error response is JSON too, but not a cart — see nwf-cart-staffel.js. */
                if (!cart || !Array.isArray(cart.items)) {
                    if (window.console) {
                        console.warn('[nwf-meterware-limited] cart attribute not written', cart);
                    }
                    return;
                }
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            })
            .catch(function () {
                passes += 1;
            })
            .finally(function () {
                running = false;
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', sync);
    } else {
        sync();
    }

    /* The cart sections re-render on every change and carry a fresh payload. */
    document.addEventListener('DOMContentLoaded', function () {
        if (typeof FoxTheme === 'undefined' || !FoxTheme.pubsub) return;
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
            window.setTimeout(sync, 0);
        });
    });
})();
